export default __webpack_public_path__ + "static/media/vehicle-3.5c5e04e8.png";